<script>
  import ShortVideoAppInstallBadges from "@/components/molecules/ShortVideoApp/installBadges.svelte";
  import { DEFAULT_META_DATA } from "@/utils/helpers/utils";
  import constants from "@/constants";
  const { DEFAULT_SRC } = constants;
  import * as css from "@/utils/css";
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  import ImageUrls from "@/constants/ImageUrls";

  const {
    qr_code_src,
    qr_code_2x_src,
    qr_code_dark_src,
    qr_code_dark_2x_src,
    bottom_play_store_link,
    footer_links,
    footer_media_links,
  } = DEFAULT_META_DATA;
  export let qrCodeSrc = qr_code_src;
  export let qrCode2xSrc = qr_code_2x_src;
  export let qrCodeDarkSrc = qr_code_dark_src;
  export let qrCodeDark2xSrc = qr_code_dark_2x_src;
  export let bottomPlayStoreLink = bottom_play_store_link;
  export let ref;
  export let theme;
  export let isIframe = false;
  export let showBanner = false;
  const { checkPropTypes, string, bool } = PropTypes;
  const propTypes = {
    qrCodeSrc: string,
    qrCode2xSrc: string,
    qr_code_2x_src: string,
    qrCodeDarkSrc: string,
    qrCodeDark2xSrc: string,
    bottomPlayStoreLink: string,
    isIframe: bool,
    showBanner: bool,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "WikiFooter");
  });
  const hasForcedTheme = theme !== undefined;
  const linkAttrs = isIframe ? { target: "_parent" } : {};
</script>

<section bind:this={ref} class="text-center sm:mb-6xl mb-xxl mt-xxl">
  <h3 class="text-md font-bold leading-[1.2] text-blue mb-xs">
    What are you waiting for?
  </h3>

  <h2
    class={`${
      hasForcedTheme
        ? `${theme === "dark" ? "text-white" : "text-black"}`
        : "text-black dark_text-white"
    } text-xl font-bold leading-[1.2] mb-lg`}
    data-testid="footer-text"
  >
    Download the Moj app today
  </h2>

  <div class="flex justify-center items-center" data-testid="footer-qrCode">
    <img
      src={DEFAULT_SRC}
      data-src={qrCodeSrc}
      data-srcset={`${qrCodeSrc} 1x,  ${qrCode2xSrc} 2x`}
      alt="Scan QR code to download Moj"
      class={`${
        hasForcedTheme
          ? `${theme === "dark" ? "hidden--sm" : "block--sm"}`
          : "block--sm dark_hidden--sm"
      } hidden w-15xl mr-4xl hover:scale-110 trs-transition lazyload`}
      height="152"
      width="152"
    />
    <img
      src={DEFAULT_SRC}
      data-src={qrCodeDarkSrc}
      data-srcset={`${qrCodeDarkSrc} 1x,  ${qrCodeDark2xSrc} 2x`}
      alt="Scan QR code to download Moj"
      class={`${
        hasForcedTheme
          ? `${theme === "dark" ? "block--sm" : "hidden--sm"}`
          : "hidden--sm dark_block--sm"
      } hidden w-15xl mr-4xl hover:scale-110 trs-transition lazyload`}
      height="152"
      width="152"
    />
    <div class="flex flex-col">
      <ShortVideoAppInstallBadges link={bottomPlayStoreLink} vertical />
    </div>
  </div>
</section>

<footer class="">
  <div
    class={`${css.allCenteredChild} flex-row mdDown:flex-col py-lg`}
    data-testid="footer-links"
  >
    {#each footer_links as link, i (i)}
      <a
        href={link.href}
        class={`${
          hasForcedTheme
            ? `${theme === "dark" ? "text-white" : "text-black"}`
            : "text-black dark_text-white"
        } text-md font-semibold leading-[1.2] px-sm lg:mb-0 mb-sm`}
        {...linkAttrs}>{link.text}</a
      >
    {/each}
  </div>

  <!-- <div class="h-4xs bg-grey" /> -->

  <div
    class={`flex justify-around items-center flex-row mdDown:flex-col ${
      showBanner ? "py-4xl" : "py-md"
    }`}
  >
    <img
      src={DEFAULT_SRC}
      data-src="/assets/png/Moj_logo.png"
      data-srcset="/assets/png/Moj_logo.png 1x, /assets/png/Moj_logo@2x.png 2x"
      alt="Moj"
      width="50"
      height="30"
      class={`${
        hasForcedTheme
          ? `${theme === "dark" ? "hidden" : "block"}`
          : "block dark_hidden"
      } lg:mb-0 mb-md lazyload`}
    />
    <img
      src={DEFAULT_SRC}
      data-src={ImageUrls.MOJ_LOGO}
      data-srcset={`${ImageUrls.MOJ_LOGO} 1x, ${ImageUrls.MOJ_LOGO_2X} 2x`}
      alt="Moj"
      width="50"
      height="30"
      class={`${
        hasForcedTheme
          ? `${theme === "dark" ? "block" : "hidden"}`
          : "hidden dark_block"
      } lg:mb-0 mb-md lazyload`}
    />

    <small
      class={`${
        hasForcedTheme
          ? `${theme === "dark" ? "text-white" : "text-black"}`
          : "text-black dark_text-white"
      } text-smd font-semibold lg:mb-0 mb-md`}
      >Mohalla Tech Pvt. Ltd. © {new Date().getFullYear()}
      All Rights Reserved
    </small>

    <div class="flex" data-testid="footer-social-media">
      {#each footer_media_links as link, i (i)}
        <a href={link.href} class="relative flex mx-xss hover" {...linkAttrs}>
          <img
            src={DEFAULT_SRC}
            data-src={link.img}
            alt={link.alt}
            class="w-lg hover:h_opacity-0 lazyload"
            width="24"
            height="24"
          />
          <img
            src={DEFAULT_SRC}
            data-src={link.img_hover}
            alt={link.alt}
            class={`${css.fullCover} opacity-0 hover:h_opacity-100 lazyload`}
            width="24"
            height="24"
          />
        </a>
      {/each}
    </div>
  </div>
</footer>
